import React from 'react'
import { affiliatesStyles } from '../index'
import Slider from 'rc-slider'
import RoundedButtonsRow from '../../../components/RoundedButtonsRow'
import COLORS from '../../../styles/colors'

interface Props {
  setAreaInterval: (string) => void
  setInfoValue: (info: string, value: any) => void
  details: any
  areaInterval: number[]
}

const InfoSection = (props: Props) => {
  return (
    <div style={styles.container}>
      <p style={affiliatesStyles.sectionTitle}>{'Informações'}</p>
      <div style={styles.row}>
        <p style={{ ...affiliatesStyles.sectionTitle, ...styles.smallTitle }}>{'Quartos'}</p>
        <RoundedButtonsRow
          type='rooms'
          hasDoesntMatter
          min={1}
          max={5}
          selectedValue={props.details['rooms']}
          setValue={props.setInfoValue}
        />
      </div>
      <div style={styles.row}>
        <p style={{ ...affiliatesStyles.sectionTitle, ...styles.smallTitle }}>{'Banheiros'}</p>
        <RoundedButtonsRow
          type='bathrooms'
          hasDoesntMatter
          min={1}
          max={5}
          selectedValue={props.details['bathrooms']}
          setValue={props.setInfoValue}
        />
      </div>
      <div style={styles.row}>
        <p style={{ ...affiliatesStyles.sectionTitle, ...styles.smallTitle }}>{'Vagas'}</p>
        <RoundedButtonsRow
          type='car_slots'
          hasDoesntMatter
          min={0}
          max={4}
          selectedValue={props.details['car_slots']}
          setValue={props.setInfoValue}
        />
      </div>
      <div style={styles.row}>
        <div style={styles.centerTextWrapper}>
          <p style={styles.centerLabel}>{'Área total do Imóvel'}</p>
          <p style={styles.centerLabel}>{`entre ${props.areaInterval[0]} m² à ${props.areaInterval[1]}m²`}</p>
        </div>
        <Slider.Range
          style={affiliatesStyles.slider}
          step={1}
          min={10}
          max={500}
          defaultValue={[10, 500]}
          onChange={(value) => props.setAreaInterval(value)}
          allowCross={false}
          trackStyle={[affiliatesStyles.trackStyle]}
          handleStyle={[affiliatesStyles.handleStyle, affiliatesStyles.handleStyle]}
          railStyle={affiliatesStyles.railStyle}
        />
      </div>
    </div>
  )
}

const styles: { [name: string]: React.CSSProperties } = {
  container: {
    padding: '20px 16px',
    backgroundColor: COLORS.lightWhite,
  },
  row: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  smallTitle: {
    fontSize: 16,
  },
  centerTextWrapper: {
    marginBottom: 5,
  },
  centerLabel: {
    color: COLORS.greyscale.black,
    fontSize: 16,
    fontWeight: 700,
  },
}

export default InfoSection
